module.exports = __webpack_public_path__ + "img/figma.e3e1f17a.svg";